import { assetUrl, homeUrl } from "@/lib/assets";
import { Link } from "@/components/common/Link";
export default function Footer() {
  return <footer style={{
    backgroundColor: 'rgb(245, 244, 242)',
    paddingTop: '64px',
    fontFamily: 'Switzer, sans-serif'
  }} className="w-full overflow-hidden !bg-[rgba(34,33,31,1)]">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Oswald:wght@300;400;500&display=swap');
        .footer-nav-pill {
          border: 1px solid rgba(255, 255, 255, 0.5);
          border-radius: 50px;
          padding: 12px 32px;
          display: flex;
          flex-wrap: wrap;
          gap: 24px;
          align-items: center;
        }
        .footer-nav-link {
          color: rgb(255, 255, 255);
          font-family: Switzer, sans-serif;
          font-size: 16px;
          font-weight: 300;
          line-height: 24px;
          text-transform: uppercase;
          text-decoration: none;
          white-space: nowrap;
          transition: opacity 0.15s ease;
        }
        .footer-nav-link:hover {
          opacity: 0.7;
        }
        .footer-social-link {
          color: rgb(255, 255, 255);
          display: flex;
          align-items: center;
          justify-content: center;
          text-decoration: none;
          transition: opacity 0.15s ease;
        }
        .footer-social-link:hover {
          opacity: 0.7;
        }
      `}</style>
      
      <div style={{
      width: '100%',
      backgroundColor: 'rgb(33, 33, 31)',
      color: 'rgb(101, 101, 101)',
      textTransform: 'uppercase',
      borderTopLeftRadius: '24px',
      borderTopRightRadius: '24px',
      padding: '48px 24px 64px',
      boxSizing: 'border-box'
    }} className="sm:px-8 md:px-12 max-w-[1400px] mx-auto">
        
        <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '32px'
      }}>
          <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '32px',
          flexWrap: 'wrap'
        }}>
            <Link to={homeUrl()}>
              <img alt="The General Council of the Assemblies of God" className="h-auto" style={{
              width: '90px'
            }} src={assetUrl("footer2.png")} />
            </Link>
            
            <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '24px',
            flexWrap: 'wrap'
          }}>
              {/* Facebook */}
              <Link to="#" className="footer-social-link" aria-label="Facebook">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
                </svg>
              </Link>

              {/* Instagram */}
              <Link to="#" className="footer-social-link" aria-label="Instagram">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg">
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                  <circle cx="12" cy="12" r="4" />
                  <circle cx="17.5" cy="6.5" r="1" fill="white" stroke="none" />
                </svg>
              </Link>

              {/* X / Twitter */}
              <Link to="#" className="footer-social-link" aria-label="X Twitter">
                
              </Link>

              {/* YouTube */}
              <Link to="#" className="footer-social-link" aria-label="YouTube">
                
              </Link>

              {/* Email */}
              <Link to="#" className="footer-social-link" aria-label="Email">
                
              </Link>
            </div>
          </div>

          <nav className="footer-nav-pill">
            <Link to="#" className="footer-nav-link">TÉRMINOS DE USO</Link>
            <Link to="#" className="footer-nav-link">POLÍTICA DE PRIVACIDAD</Link>
          </nav>
        </div>

        <div style={{
        borderTop: '1px solid rgba(255, 255, 255, 0.2)',
        marginTop: '48px',
        marginBottom: '24px'
      }} />

        <div className="flex flex-col md:flex-row md:justify-between md:items-end gap-2">
          <div>
            <p style={{
            color: 'rgb(101, 101, 101)',
            fontFamily: 'Switzer, sans-serif',
            fontSize: '12px',
            fontWeight: '300',
            lineHeight: '21px',
            textTransform: 'uppercase',
            margin: '0',
            padding: '0'
          }}>DERECHOS DE AUTOR 2026 POR EL CONCILIO GENERAL DE LAS ASAMBLEAS DE DIOS</p>
            
            <p style={{
            color: 'rgb(101, 101, 101)',
            fontFamily: 'Switzer, sans-serif',
            fontSize: '12px',
            fontWeight: '300',
            lineHeight: '21px',
            textTransform: 'uppercase',
            margin: '0',
            padding: '0'
          }}>MORAVIA, SAN JOSÉ COSTA RICA</p>
          </div>

          <div>
            <p style={{
            color: 'rgb(101, 101, 101)',
            fontFamily: 'Switzer, sans-serif',
            fontSize: '12px',
            fontWeight: '300',
            lineHeight: '21px',
            textTransform: 'uppercase',
            margin: '0',
            padding: '0'
          }}>
              TODOS LOS DERECHOS RESERVADOS
            </p>
            <p style={{
            color: 'rgb(150, 150, 146)',
            fontFamily: 'Switzer, sans-serif',
            fontSize: '12px',
            fontWeight: '500',
            lineHeight: '21px',
            textTransform: 'none',
            margin: '2px 0 0',
            padding: '0'
          }}>
              Hecho por ACAD Costa Rica y Gabriel Alvarez
            </p>
          </div>
        </div>

      </div>
    </footer>;
}
